import React from 'react';

const TransferIcon = () => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M6 15.0002V16.4495C6 16.6566 5.83211 16.8245 5.625 16.8245C5.53727 16.8245 5.45233 16.7937 5.38493 16.7375L2.2957 14.1632C2.13659 14.0306 2.1151 13.7942 2.24768 13.6351C2.31893 13.5496 2.42448 13.5002 2.53577 13.5002H13.5C14.3284 13.5002 15 12.8285 15 12.0002V6.00013H16.5V12.0002C16.5 13.657 15.1568 15.0002 13.5 15.0002H6ZM12 3.00013V1.55078C12 1.34368 12.1679 1.17578 12.375 1.17578C12.4627 1.17578 12.5477 1.20654 12.6151 1.2627L15.7043 3.83706C15.8634 3.96965 15.8849 4.20611 15.7523 4.36522C15.6811 4.45071 15.5755 4.50014 15.4642 4.50014L4.5 4.50013C3.67157 4.50013 3 5.17171 3 6.00013V12.0002H1.5V6.00013C1.5 4.34328 2.84314 3.00013 4.5 3.00013H12Z'
      fill='#212121'
    />
  </svg>
);

export default TransferIcon;
